var map = {
	"./bar.min.html": "7053",
	"./classic--medium--0-reviews.html": "0f9a",
	"./classic--medium--1-reviews.html": "c3ea",
	"./classic--medium--2-reviews.html": "1e19",
	"./classic--mini--0-reviews.html": "6b52",
	"./classic--mini--1-reviews.html": "0b22",
	"./classic--mini--2-reviews.html": "bada",
	"./floating-widget-preview.mp4": "9f59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d56";